import React from "react"

export default ({ name = "background-size", selector } = {}) => ({
  name,
  type: "background-size",
  component: ({ onChange }) => {
    return (
      <div>
        <button type="button" value="cover" onClick={onChange}>
          Cover
        </button>
        <button type="button" value="contain" onClick={onChange}>
          Contain
        </button>
      </div>
    )
  },
  css: value => {
    return `
      ${selector} { background-size: ${value || "cover"} ;}
    `
  }
})
